module.exports = __webpack_public_path__ + "img/谢玉明.d2fb6d83.jpg";